module.exports = __webpack_public_path__ + "img/pic_290572.e9705fe1.jpg";